import Backdrop from "@mui/material/Backdrop";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import DeleteButton from "../Buttons/DeleteButton";

interface Props {
  params: any;
  handleClickOpen: () => void;
  open: boolean;
  handleClose: () => void;
  clickDeteleteApi: (e: any) => void;
  deleteString: string;
  deleteTitle: string;
  deleteConfirmation: string;
  disagree: string;
  agree: string;
}

const CommonDeleteModal = ({
  params,
  handleClickOpen,
  open,
  handleClose,
  clickDeteleteApi,
  deleteString,
  deleteTitle,
  deleteConfirmation,
  disagree,
  agree,
}: Props) => {
  if (!params.isUninitialized && params.isLoading) {
    // application is being modified. show progress indicator
    return (
      <>
        <DeleteButton label={deleteString} />
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </>
    );
  }

  if (!params.isUninitialized && params.isSuccess) {
    return <DeleteButton label={deleteString} />;
  }

  if (!params.isUninitialized && params.isError) {
    return <DeleteButton label={deleteString} />;
  }

  return (
    <div>
      <DeleteButton label={deleteString} onClickHandler={handleClickOpen} />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{deleteTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {deleteConfirmation}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{disagree}</Button>
          <Button onClick={clickDeteleteApi} autoFocus>
            {agree}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CommonDeleteModal;
